<template>
  <div id="multivariate-home">
    <PluginHeader
      title="Multivariate Zoning"
      subtitle="K-means clustering across many variables"
      icon="fas fa-chart-scatter"
    />
    <AlertMessage />
    <ChooseDatasets />
  </div>
</template>

<script>
import AlertMessage from './AlertMessage.vue'
import ChooseDatasets from './ChooseDatasets.vue'
import PluginHeader from '../_shared/PluginHeader.vue'
import multivariateModule from './store/module.js'

export default {
  components: { AlertMessage, ChooseDatasets, PluginHeader },
  beforeCreate () {
    // Register the namespaced module fresh on entry so each visit
    // starts from clean state (empty chosenDatasets, empty vectors,
    // root folder, etc.).
    if (!this.$store.hasModule || !this.$store.hasModule('multivariate')) {
      this.$store.registerModule('multivariate', multivariateModule)
    }
  },
  beforeDestroy () {
    if (this.$store.hasModule && this.$store.hasModule('multivariate')) {
      this.$store.unregisterModule('multivariate')
    }
  }
}
</script>

<style scoped>
/* Cover the legacy plugin's body background (was black) so the page
   reads on the same neutral surface as the rest of myEV. Content
   starts under the shared 56px plugin header. */
#multivariate-home {
  position: fixed;
  inset: 0;
  padding-top: 56px;
  background: #f7f9fa;
  overflow-y: auto;
}
</style>
